<template>
    <div>
        <label>{{ i18n("voucherDesign.backgroundImage") }}:</label>
        <div>
            <button
                type="button"
                class="btn btn-sm btn-success"
                :disabled="isUploadingBackgroundImage"
                @click="triggerBackgroundImageUpload"
            >
                {{ i18n("voucherDesign.upload") }}
            </button>
            <span class="kt-spinner kt-spinner--sm kt-spinner--success ml-1" v-if="isUploadingBackgroundImage"></span>
            <button
                v-if="modelValue"
                type="button"
                class="btn btn-sm btn-danger ml-2"
                :disabled="isUploadingBackgroundImage"
                @click="clearBackgroundImage"
            >
                {{ i18n("voucherDesign.clear") }}
            </button>

            <input
                ref="bgImageFileInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="onImageSelected"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { Factory } from "@/data/dao/Factory";
    import { LocationDao } from "@/data/dao/service/LocationDao";
    import { i18n } from "@/portal/Trans";
    import { ref } from "vue";

    const locationDao = Factory.getInstance<LocationDao>(LocationDao);

    const modelValue = defineModel<string | null>("backgroundImage", { required: true });
    const modelImageId = defineModel<string | null>("backgroundImageId", { required: true });

    const props = defineProps<{
        locationId: string;
    }>();

    const isUploadingBackgroundImage = ref(false);
    const bgImageFileInput = ref<HTMLInputElement | null>(null);

    async function onImageSelected(event: Event) {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (!file) return;

        try {
            isUploadingBackgroundImage.value = true;
            const image = await locationDao.uploadVoucherDesignImage(props.locationId, {
                image: file,
            });

            modelValue.value = image.imageUrl;
            modelImageId.value = image.id;
        } finally {
            isUploadingBackgroundImage.value = false;
            if (bgImageFileInput.value) {
                bgImageFileInput.value.value = "";
            }
        }
    }

    function clearBackgroundImage() {
        modelValue.value = null;
        modelImageId.value = null;
    }

    function triggerBackgroundImageUpload() {
        bgImageFileInput.value?.click();
    }
</script>
